import { Download } from "lucide-react";
import { useRef } from "react";

import AnalyticsChartToolbarButton from "./AnalyticsChartToolbarButton";
import AnalyticsGraphChartCardShell from "./AnalyticsGraphChartCardShell";
import { type AnalyticsChartFrameHandle } from "./AnalyticsChartFrame";
import { buildAgChartsOptionsChart } from "./chartOptions/agChartsOptionsChart";

interface AgChartsOptionsChartCardProps {
  title: string;
  downloadFileName: string;
  chartOptions: ReturnType<typeof buildAgChartsOptionsChart>;
  resetKey: string;
  isEmpty: boolean;
  className?: string;
}

const AgChartsOptionsChartCard = ({
  title,
  downloadFileName,
  chartOptions,
  resetKey,
  isEmpty,
  className,
}: AgChartsOptionsChartCardProps) => {
  const chartFrameRef = useRef<AnalyticsChartFrameHandle>(null);

  return (
    <AnalyticsGraphChartCardShell
      title={title}
      chartOptions={chartOptions}
      resetKey={resetKey}
      isLoading={false}
      isEmpty={isEmpty}
      className={className}
      chartFrameRef={chartFrameRef}
      toolbarActions={
        <AnalyticsChartToolbarButton
          ariaLabel="Download chart"
          disabled={isEmpty}
          icon={Download}
          onClick={() => chartFrameRef.current?.downloadChart(downloadFileName)}
          tooltip="Download chart"
        />
      }
    />
  );
};

export default AgChartsOptionsChartCard;
